import API_BASE, { protectedApiFetch } from "../../api";
import {
  FISHING_TODAY_LOCATION_SOURCE,
  isCoordinateFishingLocation,
  roundFishingCoordinate,
} from "./fishingTodayLocation";

export class FishingTodayApiError extends Error {
  constructor(message, { code = "fishing_today_unavailable", status = 0 } = {}) {
    super(message);
    this.name = "FishingTodayApiError";
    this.code = code;
    this.status = status;
  }
}

const readPayload = async (response) => {
  try {
    return await response.json();
  } catch (_error) {
    return null;
  }
};

export async function fetchFishingToday({ location, signal } = {}) {
  const url = new URL(`${API_BASE}/home/fishing-today`, window.location.origin);

  if (
    location &&
    (location.source === FISHING_TODAY_LOCATION_SOURCE.LIVE ||
      location.source === FISHING_TODAY_LOCATION_SOURCE.FAVORITE_SPOT)
  ) {
    if (!isCoordinateFishingLocation(location)) {
      throw new TypeError("Precise location requires finite latitude and longitude.");
    }

    url.searchParams.set("lat", String(roundFishingCoordinate(location.latitude)));
    url.searchParams.set("lng", String(roundFishingCoordinate(location.longitude)));
  }

  const requestUrl = /^https?:/i.test(API_BASE)
    ? url.toString()
    : `${url.pathname}${url.search}`;
  const response = await protectedApiFetch(requestUrl, {
    method: "GET",
    cache: "no-store",
    signal,
  });
  const payload = await readPayload(response);

  if (!response.ok) {
    const detail = payload?.detail;
    const code =
      (typeof detail === "object" && detail?.code) ||
      (response.status === 422 ? "location_unavailable" : "fishing_today_unavailable");
    const message =
      (typeof detail === "object" && detail?.message) ||
      (typeof detail === "string" && detail) ||
      "Fishing conditions are temporarily unavailable.";

    throw new FishingTodayApiError(message, {
      code,
      status: response.status,
    });
  }

  return payload;
}
